import React from 'react';
import {CardBody} from './card-features/CardBody';
import {CardWrapper} from './card-features/CardWrapper';
import {CardBtnGroup} from './card-features/CardBtnGroup';
import {CardHeader} from './card-features/CardHeader';

const Card = ({children, deletable, cornerBtn, hoverCornerBtn, size, cardHeader, ...props}) => (
    <Card.Wrapper deletable={deletable} size={size} hoverCornerBtn={hoverCornerBtn} {...props}>
        {cardHeader && <Card.Header>{cardHeader}</Card.Header>}
        {cornerBtn && <Card.BtnGroup> {cornerBtn}</Card.BtnGroup>}
        {hoverCornerBtn && <Card.BtnGroup> {hoverCornerBtn}</Card.BtnGroup>}
        <Card.Body>{children}</Card.Body>
    </Card.Wrapper>
);

Card.Wrapper = CardWrapper;
Card.Body = CardBody;
Card.Header = CardHeader;
Card.BtnGroup = CardBtnGroup;
export {Card, CardBody, CardWrapper};
